export const GridKeys = {
  Users: 'users',
  Courses: 'courses',
  Tenants: 'tenants',
  Projects: 'projects',
  Children: 'children',
  UsersLogs: 'users-logs',
  LibraryTags: 'library-tags',
  ProfileForms: 'profile-forms',
  PdfManagement: 'pdf-management',
  CoursesProject: 'courses-project',
  TenantsProject: 'tenants-project',
  PdfActivityLogs: 'pdf-activity-logs',
  LibraryResources: 'library-resources',
} as const;
